// Module
var code = "<div class=\"basket-email-sender\"> <div class=\"basket-email-sender__input-container\"> <input class=\"basket-email-sender__input\" role=\"text\" type=\"email\" placeholder=\"[[EmailExampleCom]]\"/> </div> <button role=\"button\" type=\"button\" class=\"basket-email-sender__button\">[[Send]]</button> </div>";
// Exports
module.exports = code;